export default "__VITE_ASSET__db6cc349__"